export const operatorOptions = ['equalTo', 'greaterThan', 'lessThan', 'greaterThanOrEqualTo', 'lessThanOrEqualTo'];

export const logicalOptions = ['and', 'or'];
